import { z } from 'zod';
import { storedFileSchema, type StoredFileDto } from '@eombor/contracts';
import type { ApiClient } from '../../../shared/api/client.js';
import { apiClient } from '../../auth/model/auth.store.js';

/**
 * «MENING IMZOYIM» — API yuzasi.
 *
 * Xodim id si SO'ROVDA yo'q va bo'lmasligi ham kerak: server uni tokendan
 * oladi. Shu tufayli mijozda «kimning imzosi» degan tanlov ham yo'q —
 * imzo har doim tugmani bosgan odamniki.
 */

const signatureSchema = z.object({ fileId: z.string().nullable() });

export type SignatureDto = z.infer<typeof signatureSchema>;

export interface SignatureApi {
  /** Joriy imzo — chizilmagan bo'lsa `fileId` `null`. */
  current: () => Promise<SignatureDto>;
  /** Chizilgan rasmni yuklaydi (`context: SIGNATURE`). */
  upload: (file: File) => Promise<StoredFileDto>;
  /** Yuklangan faylni joriy imzo qilib belgilaydi. */
  set: (fileId: string) => Promise<SignatureDto>;
}

export const createSignatureApi = (client: ApiClient): SignatureApi => ({
  current: () => client.apiFetch('/me/signature', { schema: signatureSchema }),

  upload: (file) => {
    const form = new FormData();
    form.set('context', 'SIGNATURE');
    form.set('file', file);
    // `Content-Type` ATAYLAB qo'yilmaydi — brauzer uni `boundary` bilan yozadi.
    return client.apiFetch('/files', { method: 'POST', body: form, schema: storedFileSchema });
  },

  set: (fileId) =>
    client.apiFetch('/me/signature', {
      method: 'PUT',
      body: JSON.stringify({ fileId }),
      schema: signatureSchema,
    }),
});

export const signatureApi = createSignatureApi(apiClient);
